import './main.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

import Store from './Store';
import EventManager from './EventManager';
import App from './components/App'


// Debug
// import * as dat from 'dat.gui'
// const gui = new dat.GUI();


// Store
// Create App
Store.setState({ app: new App() });

// events
const eventManager = new EventManager();

// get store state for functions
const store = Store.getState();
const { camera, renderer, bloomComposer, finalComposer, bloomLayer, sizes, scene, canvas, } = store;
const darkMaterial = new THREE.MeshBasicMaterial({ color: 'black' });
const materials = {};

window.addEventListener('resize', () => {
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight

  // Update camera
  camera.aspect = sizes.width / sizes.height // Using the camera from the App class
  camera.updateProjectionMatrix()

  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  bloomComposer.setSize(sizes.width, sizes.height);
  finalComposer.setSize(sizes.width, sizes.height);

  // update anything else in app 
  store.app.resize();
})


renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Animation
const animate = function() {
  requestAnimationFrame(animate);

  store.app.update(); // Call update method from App class

  // render the entire scene, then render bloom scene on top
  scene.traverse(darkenNonBloomed);
  bloomComposer.render();
  scene.traverse(restoreMaterial);
  finalComposer.render();

  // default renderer for testing
  // renderer.render(scene, camera);
};

const darkenNonBloomed = (obj) => {
  if (obj.isMesh && bloomLayer.test(obj.layers) === false) {
    materials[obj.uuid] = obj.material;
    obj.material = darkMaterial;
  }
}

const restoreMaterial = (obj) => {
  if (materials[obj.uuid]) {
    obj.material = materials[obj.uuid];
    delete materials[obj.uuid];
  }
}


// preload textures
store.app.preload();

// call animate function
animate();